import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[autoFocus]'
})
export class AutoFocusDirective {
  constructor(private elRef: ElementRef) { }

  ngOnInit(): void {
    this.elRef.nativeElement.focus();
  }
}
